import React, { ReactElement } from "react";
import { IMarketStatus } from "../../types/stream";
import IndexComp from "./partials/indexStreamJSX";
import DeviceContext from "../../service/indentifyDevice";
import { Idevice } from "../../types/device";
import * as symbols from "../../../ds/symbols.json";
import urlConfig from "../../../config/domain";
import { apiService } from "../../service/apiService";
import { initWS } from "../../service/edelWebSockets/wsCallbacks";
import { edelSocketQuote1Req } from "../../service/edelWebSockets/wsInit";
import { IQuoteRes, ISocketSubscribeReq } from "../../types/components/edelSockets/edelSocketTypes";

//props to show the streaming on top of the  header
//with label as NIFTY/SENSEX,
//ltp, ltpchg ltpchgper, all made optional beacuse these parameters dependent on API response or socket message
export interface IIdxStreamProps {
	label?: string;
	ltp?: any;
	ltpchg?: any;
	ltpchgper?: any;
}
//index stream component created with the state where res holds the intial API response,
//this will be used until we get first socket message
//apiRes - > api response(GetMarketStatus)
//res - > socket message response
//device provide the type of device

const handleDevice: Idevice = DeviceContext();

export function IdxStream(_props: IIdxStreamProps) {
	let streamRes: { NSE: IQuoteRes | undefined; BSE: IQuoteRes | undefined } = { NSE: undefined, BSE: undefined };

	const [NSEObj, setNSEObj] = React.useState<ReactElement>(
		<IndexComp label={symbols.niftyEdelCode} ltp={0} ltpchg={0} ltpchgper={0} device={handleDevice} />
	);
	const [BSEObj, setBSEObj] = React.useState<ReactElement>(
		<IndexComp label={symbols.sensexEdelCode} ltp={0} ltpchg={0} ltpchgper={0} device={handleDevice} />
	);
	const [USDObj, setUSDObj] = React.useState<ReactElement>(
		<IndexComp label={symbols.usdEdelCode} ltp={0} ltpchg={0} ltpchgper={0} device={handleDevice} />
	);
	const [BANKObj, setBANKObj] = React.useState<ReactElement>(
		<IndexComp label={symbols.niftyBank} ltp={0} ltpchg={0} ltpchgper={0} device={handleDevice} />
	);
	//streamer callback method
	const socketMessages = (message: any, type: string) => {
		if (type === "message") {
			const msgJson = JSON.parse(message) as {
				response: {
					data: IQuoteRes;
				};
				streaming_type: string;
			};

			//streamer will send the single message for both symbols, depending the received symbol
			//status need to be updated

			let parsedData = msgJson.response.data;

			if (parsedData.sym === symbols.NSESymbol || parsedData.sym === symbols.BSESymbol) {
				//after receiving first message reset the apiRes to undefined because from this we will be using sockets data
				//reset only if data recevied for NIFTY and SENSEX

				if (
					parsedData.sym === symbols.NSESymbol &&
					(parsedData.ltp !== streamRes.NSE?.ltp || parsedData.chg !== streamRes.NSE?.chg || parsedData.chgp !== streamRes.NSE?.chgp)
				) {
					streamRes.NSE = parsedData;
					setNSEObj(
						<IndexComp
							label={symbols.niftyEdelCode}
							ltp={parseFloat(parsedData.ltp).toFixed(2)}
							ltpchg={parseFloat(parsedData.chg).toFixed(2)}
							ltpchgper={parseFloat(parsedData.chgp).toFixed(2)}
							device={handleDevice}
							className={parseFloat(parsedData.chg) >= 0 ? "green" : "red"}
						/>
					);
				}
				if (
					parsedData.sym === symbols.BSESymbol &&
					(parsedData.ltp !== streamRes.BSE?.ltp || parsedData.chg !== streamRes.BSE?.chg || parsedData.chgp !== streamRes.BSE?.chgp)
				) {
					streamRes.BSE = parsedData;

					setBSEObj(
						<IndexComp
							label={symbols.sensexEdelCode}
							ltp={parseFloat(parsedData.ltp).toFixed(2)}
							ltpchg={parseFloat(parsedData.chg).toFixed(2)}
							ltpchgper={parseFloat(parsedData.chgp).toFixed(2)}
							device={handleDevice}
							className={parseFloat(parsedData.chg) >= 0 ? "green" : "red"}
						/>
					);
				}
			}
		}
	};

	const marketStatSuccess = (res: any) => {
		if (res) {
			let parsedData = JSON.parse(res).JsonData as IMarketStatus;

			setNSEObj(
				<IndexComp
					label={symbols.niftyEdelCode}
					ltp={(parsedData.NSE).toFixed(2)}
					ltpchg={(parsedData.NSEchg).toFixed(2)}
					ltpchgper={(parsedData.NSEchgp).toFixed(2)}
					device={handleDevice}
					className={parsedData.NSEchg >= 0 ?  "green" : "red"}
				/>
			);
			setBSEObj(
				<IndexComp
					label={symbols.sensexEdelCode}
					ltp={(parsedData.BSE).toFixed(2)}
					ltpchg={(parsedData.BSEchg).toFixed(2)}
					ltpchgper={(parsedData.BSEchgp).toFixed(2)}
					device={handleDevice}
					className={parsedData.BSEchg >= 0 ?  "green" : "red"}
				/>
			);
		}
	};
	const marketStatSuccessOverview = (res: any) => {
		if (res) {
			let parsedData = JSON.parse(res).JsonData ;
			if(parsedData.OKIndices && parsedData.OKIndices.length > 0){
				let OKIndices = parsedData.OKIndices[0] ;

				setUSDObj(
					<IndexComp
						label={symbols.usdEdelCode}
						ltp={parseFloat(OKIndices.LTP).toFixed(2)}
						ltpchg={parseFloat(OKIndices.Change).toFixed(2)}
						ltpchgper={parseFloat(OKIndices.ChangePer).toFixed(2)}
						device={handleDevice}
						className={OKIndices.Change >= 0 ?  "green" : "red"}
					/>
				);
			}
			
		}
	};
	const marketStatSuccessIndices = (res: any) => {
		if (res) {
			let parsedData = JSON.parse(res).JsonData.KI ;
			if(parsedData.NSE && parsedData.NSE.length > 0){
				let nifty = parsedData.NSE[1] ;

				setBANKObj(
					<IndexComp
						label={symbols.niftyBank}
						ltp={parseFloat(nifty.LTP).toFixed(2)}
						ltpchg={parseFloat(nifty.Chng).toFixed(2)}
						ltpchgper={parseFloat(nifty.PChng).toFixed(2)}
						device={handleDevice}
						className={nifty.Change >= 0 ?  "green" : "red"}
					/>
				);
			}
			
		}
	};

	React.useEffect(() => {
		apiService({ url: urlConfig.market.status + symbols.niftyCoCode + "," + symbols.sensexCoCode, method: "GET" }, marketStatSuccess);
		apiService({ url: urlConfig.usd.status, method: "GET" }, marketStatSuccessOverview);
		apiService({ url: urlConfig.banknifty.status, method: "GET" }, marketStatSuccessIndices);

		

		// initWS<ISocketSubscribeReq>(
		// 	edelSocketQuote1Req("quote", {
		// 		symbols: [{ symbol: symbols.NSESymbol }, { symbol: symbols.BSESymbol }]
		// 	}),
		// 	socketMessages
		// );
		return () => {
			// initWS<ISocketSubscribeReq>(
			// 	edelSocketQuote1Req(
			// 		"quote",
			// 		{
			// 			symbols: [{ symbol: symbols.NSESymbol }, { symbol: symbols.BSESymbol }]
			// 		},
			// 		"unsubscribe"
			// 	),
			// 	socketMessages
			// );
		};
	}, []);
	return (
		<div className="topShare vMid">
			<ul>
				<li>{NSEObj}</li>
				<li>{BSEObj}</li>
				{DeviceContext().isDesktop && (
					<>
					<li>{USDObj}</li>
					<li>{BANKObj}</li></>
				)}
			</ul>
		</div>
	);
}
